function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.4
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_20023161_77826)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 9.458V6.542C14.568 6.03133 14.1827 6.00733 13.982 5.52267C13.78 5.03667 14.0373 4.74333 14.688 3.374L12.626 1.312C11.2753 1.954 10.9673 2.22133 10.4767 2.018C9.992 1.81667 9.96467 1.42533 9.45867 0H6.542C6.03267 1.42933 6.00867 1.81667 5.52267 2.018C5.02133 2.22667 4.72067 1.95133 3.374 1.312L1.312 3.374C1.96333 4.744 2.22 5.036 2.018 5.52333C1.81667 6.008 1.43067 6.03267 0 6.542V9.45867C1.426 9.96533 1.81667 9.992 2.018 10.4773C2.22067 10.9667 1.964 11.2553 1.312 12.626L3.374 14.688C4.70667 14.0547 5.02067 13.7727 5.52267 13.982C6.008 14.1833 6.032 14.5687 6.542 16H9.458C9.96333 14.5793 9.99067 14.1847 10.4827 13.9793C10.9793 13.774 11.2733 14.0453 12.626 14.6873L14.688 12.6253C14.038 11.2587 13.78 10.964 13.982 10.4767C14.182 9.99267 14.5687 9.968 16 9.458V9.458ZM12.75 9.96733C12.3653 10.8967 12.7047 11.606 13.0753 12.3527L12.3527 13.0753C11.624 12.7133 10.912 12.358 9.97067 12.7487C9.04 13.136 8.77733 13.8773 8.512 14.6667H7.48933C7.224 13.8767 6.962 13.1353 6.034 12.75C5.088 12.358 4.36267 12.72 3.648 13.0753L2.926 12.3527C3.29733 11.6073 3.63667 10.8993 3.25067 9.966C2.86467 9.03867 2.12333 8.77667 1.33333 8.51133V7.48933C2.12333 7.224 2.86467 6.962 3.25 6.03333C3.63533 5.104 3.29533 4.394 2.92467 3.64733L3.64733 2.92467C4.36867 3.28333 5.08867 3.64267 6.034 3.25C6.962 2.86533 7.224 2.12333 7.48933 1.33333H8.512C8.77733 2.12333 9.04 2.86467 9.968 3.25C10.914 3.642 11.6387 3.28 12.354 2.92467L13.0767 3.64733C12.706 4.39467 12.3667 5.10533 12.7513 6.034C13.136 6.96133 13.8773 7.22333 14.668 7.48933V8.512C13.876 8.77733 13.1333 9.03933 12.75 9.96733V9.96733ZM8 6C9.10267 6 10 6.89733 10 8C10 9.10267 9.10267 10 8 10C6.89733 10 6 9.10267 6 8C6 6.89733 6.89733 6 8 6ZM8 4.66667C6.15867 4.66667 4.66667 6.15867 4.66667 8C4.66667 9.84133 6.15867 11.3333 8 11.3333C9.84133 11.3333 11.3333 9.84133 11.3333 8C11.3333 6.15867 9.84133 4.66667 8 4.66667Z",
  fill: "white"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_20023161_77826"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.a117dacf78c22e4872a7b9eb732b99b6.svg";
export { ForwardRef as ReactComponent };